// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__sSEhh","userInfoText":"styles_userInfoText__V1NDe","contactInfoWrapper":"styles_contactInfoWrapper__0bsyh"};